import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { AuthFetchService } from './fetch-with-auth';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private apiUrl = `${environment.apiUrl}/users`;
  private authFetch: AuthFetchService;
  private cachedUser: any = null; // Cache do usuário
  private loadingPromise: Promise<any> | null = null; // Promise compartilhada para evitar múltiplas chamadas simultâneas

  constructor(private router: Router, private http: HttpClient) {
    this.authFetch = new AuthFetchService();
  }

  /**
   * Busca os dados do usuário atual
   * Usa cache e promise compartilhada para evitar múltiplas chamadas simultâneas ao /me
   */
  getMe(forceRefresh: boolean = false): Promise<any> {
    // Se já tem cache e não está forçando refresh, retornar cache
    if (this.cachedUser && !forceRefresh) {
      return Promise.resolve(this.cachedUser);
    }

    // Se já existe uma requisição em andamento, aguardar ela
    if (this.loadingPromise) {
      return this.loadingPromise;
    }

    // Criar promise compartilhada para evitar múltiplas chamadas simultâneas
    this.loadingPromise = this.authFetch.fetchWithAuth(`${this.apiUrl}/me`)
      .then(response => {
        if (!response.ok) {
          throw new Error('Erro ao buscar dados do usuário', {
            cause: response
          });
        }
        return response.json().then(user => {
          if (user && user.id !== undefined && user.id !== null) {
            try {
              localStorage.setItem('customerId', String(user.id));
            } catch (e) {
              console.warn('Não foi possível armazenar customerId no localStorage:', e);
            }
          }
          // Cachear o usuário
          this.cachedUser = user;
          this.loadingPromise = null;
          return user;
        });
      })
      .catch(error => {
        // Limpar cache em caso de erro
        this.cachedUser = null;
        this.loadingPromise = null;
        
        // Armazene o JWT no localStorage
        if (error.cause && error.cause.status == 401) {
          localStorage.removeItem('jwt');
          localStorage.removeItem('customerId');
          // Não redirecionar se estiver na landing page
          if (this.router.url !== '/' && this.router.url !== '') {
            this.router.navigate(['/login']);
          }
        } else {
          console.error('Erro ao carregar dados do usuário:', error);
        }
        return null;
      });

    return this.loadingPromise;
  }

  /**
   * Limpa o cache do usuário (útil para logout ou refresh)
   */
  clearUserCache(): void {
    this.cachedUser = null;
    this.loadingPromise = null;
  }

  

  savePrintName(printerName: string): Promise<any> {

    const requestOptions = {
      method: "POST",
      body: JSON.stringify(printerName)
    };

    return this.authFetch.fetchWithAuth(`${environment.apiUrl}/settings`, requestOptions)
      .then(response => {
        if (!response.ok) {
          throw new Error('Erro ao salvar nome da impressora', {
            cause: response
          });
        }
        return true;
      })
      .catch(error => {
        // Armazene o JWT no localStorage
        if (error.cause && error.cause.status == 401) {
          localStorage.removeItem('jwt');
          this.router.navigate(['/login']);
        } else {
          console.error('Erro ao salvar nome da impressora:', error);
        }
        return false;
      });
  }

  saveSettings(printerName: string, printFormat: string): Promise<any> {
    const settings = {
      printerName: printerName,
      printFormat: printFormat
    };

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(settings)
    };

    return this.authFetch.fetchWithAuth(`${environment.apiUrl}/settings`, requestOptions)
      .then(response => {
        if (!response.ok) {
          throw new Error('Erro ao salvar configurações', {
            cause: response
          });
        }
        return true;
      })
      .catch(error => {
        if (error.cause && error.cause.status == 401) {
          localStorage.removeItem('jwt');
          this.router.navigate(['/login']);
        } else {
          console.error('Erro ao salvar configurações:', error);
        }
        return false;
      });
  }

  getAccounts(): Promise<any[]> {
    return this.authFetch.fetchWithAuth(`${this.apiUrl}/accounts`)
      .then(response => {
        if (!response.ok) {
          throw new Error('Erro ao buscar contas', {
            cause: response
          });
        }
        return response.json();
      })
      .catch(error => {
        if (error.cause && error.cause.status == 401) {
          localStorage.removeItem('jwt');
          localStorage.removeItem('customerId');
          // Não redirecionar se estiver na landing page
          if (this.router.url !== '/' && this.router.url !== '') {
            this.router.navigate(['/login']);
          }
        } else {
          console.error('Erro ao carregar contas:', error);
        }
        return [];
      });
  }


}
